/**
 * @generated SignedSource<<ccd6d39f63dedb1a0d147e4169ab79c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicSearchResultListTopicSearchConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly content: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"topicSearchResultListItemTopic">;
      } | null | undefined;
      readonly score: number | null | undefined;
    };
  }>;
  readonly " $fragmentType": "topicSearchResultListTopicSearchConnection";
};
export type topicSearchResultListTopicSearchConnection$key = {
  readonly " $data"?: topicSearchResultListTopicSearchConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicSearchResultListTopicSearchConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicSearchResultListTopicSearchConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TopicSearchEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TopicSearchResultItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "score",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Topic",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "topicSearchResultListItemTopic"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TopicSearchConnection",
  "abstractKey": null
};

(node as any).hash = "6fea6fbd971bf0e4a51526dc0e3de2d6";

export default node;
